<template>
  <div id="app">
    <van-nav-bar title="ZENG.INK" />
    <div class="content">
        <van-loading v-if="isLoading" type="circular" color="#1989fa" />
        <router-view v-else/>
    </div>
    <van-tabbar v-model="active">
      <van-tabbar-item to="/" icon="https://oss-capi.zeng.ink/file/1738160903037_yjtx.png">首页</van-tabbar-item>
      <van-tabbar-item to="/dm" icon="contact-o">联系T<sup>2</sup></van-tabbar-item>
      <van-tabbar-item to="/more" icon="apps-o">T<sup>2</sup>的网站</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<style lang="less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  --van-animation-duration-base: 0.2s;
}
#app {
  width: 100%;
  margin: 0 auto;
}
.van-nav-bar {
  width: 100%;
  background-color: #badcfa !important;
}
.content {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 96px); /* 减去导航栏和底部标签栏的高度 */
  padding: 10px;
}
</style>

<script>
export default {
  data() {
    return {
      active: 0,
      isLoading: false
    }
  },
  watch: {
    $route() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    }
  }
}
</script>